export interface Article {
    articleId: string;
    title: string;
    content: string;
    description: string;
    mainImageUrl: string;
    isDeleted: boolean;
    isEnabled: boolean;
    category: Category;
    tags: string[];
    createdAt: string;
    categoryName: string;
}

export interface Image {
    imageUrl: string;
    type: ImageType;
    title: string;
    content: string;
    source: string;
    credit: string;
}

export enum ImageType {
    MainImage = 'MainImage',
    ArticleImage = 'ArticleImage',
    SlideShowImage = 'SlideShowImage'
}

export enum Category
{
    News = 'News',
    Sports = 'Sports',
    FoodAndDrinks= 'Food & Drinks',
    Technology = 'Technology',  
    Pets= 'Pets',
    Travel = 'Travel',
    Entertainment= 'Entertainment',
    Fashion = 'Fashion',
    Health = 'Health',
    Lifestyle = 'Lifestyle',
    Autos= 'Autos',
    Business = 'Business',
    Education = 'Education',
    Politics = 'Politics',
    Money= 'Money',
    Science = 'Science',
    WorldNews= 'World News',
    Others = 'Others'
}